import React, { useState, useEffect } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../hooks/api';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!success) return;
    const t = setTimeout(() => navigate('/login'), 2500);
    return () => clearTimeout(t);
  }, [success, navigate]);

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-card">
          <img src="/logo.png" alt="AB Jewels" className="login-logo-img" />
          <div className="alert alert-error">Missing reset token. Use the link from the email.</div>
          <p style={{ textAlign: 'center', marginTop: 14, fontSize: 13 }}>
            <Link to="/forgot-password" style={{ color: 'var(--text-muted)' }}>Request a new link</Link>
          </p>
        </div>
      </div>
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, password });
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/logo.png" alt="AB Jewels" className="login-logo-img" />
        <p className="login-subtitle">Set a new password</p>

        {success ? (
          <>
            <div className="alert alert-success">
              Password updated successfully. Redirecting to sign in…
            </div>
            <p style={{ textAlign: 'center', marginTop: 14, fontSize: 13 }}>
              <Link to="/login">Sign in now</Link>
            </p>
          </>
        ) : (
          <>
            {error && <div className="alert alert-error">{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>New password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required autoFocus minLength={8} />
              </div>
              <div className="form-group">
                <label>Confirm new password</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required minLength={8} />
              </div>
              <button className="btn btn-primary btn-block" disabled={loading}>
                {loading ? 'Updating…' : 'Update password'}
              </button>
            </form>
            <p style={{ textAlign: 'center', marginTop: 14, fontSize: 13 }}>
              <Link to="/login" style={{ color: 'var(--text-muted)' }}>Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
